import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Nax",
    desc: "Pose de carrelage à Nax et dans les hameaux alpins. Matériaux solides, joints droits, et un boulot qui résiste aux hivers de Mont-Noble.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Nax",
    desc: "Rénovation de salle de bain à Nax. On modernise les équipements, on renforce l'étanchéité, on pose du carrelage chaleureux. Un chantier complet pour les résidences de montagne.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Nax",
    desc: "Douche italienne à Nax. Pratique et esthétique dans les salles de bain des chalets et appartements de la station. Pente calculée, carrelage antidérapant.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Nax",
    desc: "Faïence et mosaïque à Nax. On personnalise les cuisines et salles de bain avec des matériaux choisis pour leur résistance aux variations de température.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Nax",
    desc: "Terrasses et allées à Nax. Carrelage technique antidérapant et résistant au gel, pour des espaces extérieurs qui tiennent face aux conditions montagnardes.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Nax",
      "item": "https://carreaux-bat.ch/nax"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Nax, Valais",
  "description": "Pose de carrelage et rénovation de salle de bain à Nax, région de Mont-Noble. Chalets traditionnels, douche italienne, carrelage résistant montagne. Artisan carreleur.",
  "url": "https://carreaux-bat.ch/nax",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Nax",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function NaxPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Nax à Proximité — Mont-Noble | Carreaux-Bat Valais"
        description="Vous cherchez un carreleur à proximité de Nax ? Entreprise de carrelage et société de carrelage à Nax, région de Mont-Noble, Valais. Service de carrelage par carreleur près de chez vous à Nax, Mase, Saint-Martin, Vernamiège. Pose de carrelage, douche italienne, terrasse. Devis gratuit."
        keywords="carreleur à proximité de Nax, entreprise de carrelage à proximité de Nax, société de carrelage à proximité de Nax, carreleur près de chez moi Nax, entreprise de carrelage près de chez vous Nax, service de carrelage à proximité Nax, entreprise de carrelage Nax, société de carrelage Nax, service de carrelage Nax, carreleur Nax, pose de carrelage Nax, rénovation salle de bain Nax, douche italienne Nax, carrelage Mont-Noble, carreleur Mase Saint-Martin, artisan carreleur Valais profond"
        canonical="https://carreaux-bat.ch/nax"
        ogTitle="Carrelage & Rénovation à Nax à Proximité — Artisan Carreleur en Mont-Noble"
        ogDescription="Vous cherchez un carreleur à proximité de Nax ? Pose de carrelage, rénovation salle de bain et douche italienne à Nax et dans la région de Mont-Noble. Chalets traditionnels et matériaux résistants montagne."
        ogImage="/images/nax-hero.jpg"
        geoPosition="46.2167;7.4667"
        geoPlacename="Nax, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/nax-hero.jpg"
          alt="Carrelage Nax Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Mont-Noble
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Nax</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Nax et la région de Mont-Noble, c'est le Valais profond. On intervient ici avec le même soin que partout ailleurs, même si les chemins sont plus étroits.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Nax</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Nax, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Nax, le charme authentique du Valais alpin</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Nax est un petit village de montagne de la commune de Mont-Noble, située dans le district d&apos;Hérens en Valais central. À 1 300 mètres d&apos;altitude et avec environ 400 habitants, Nax incarne le charme discret et authentique des villages alpins valaisans qui ont su résister à l&apos;urbanisation intensive.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Carreleur à Nax — Pose de carrelage pour chalets traditionnels</h3>
                <p>
                  La commune de Mont-Noble est la plus petite du canton du Valais en termes de surface, mais elle regorge de trésors naturels et patrimoniaux. Le village de Nax est dominé par le sommet du Mont-Noble qui culmine à 2 673 mètres, et est entouré de pâturages d&apos;alpage où les vaches valaisannes paissent pendant l&apos;été. L&apos;agriculture de montagne reste une activité centrale, avec la fabrication du fromage d&apos;alpage et la production de miel local.
                </p>
                <p>
                  Nax est un lieu de vie paisible, loin de l&apos;effervescence des grandes stations touristiques. Les habitants vivent au rythme des saisons, avec une forte culture de l&apos;entraide et des traditions qui se transmettent de génération en génération. Le village possède une église baroque classée, des greniers typiques valaisans en boden, et des ruelles étroites qui témoignent d&apos;un passé agricole et montagnard.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Nax — Rénovation salle de bain et douche italienne</h3>
                <p>
                  Bien que modeste en taille, le village de Nax et la région de Mont-Noble connaissent un intérêt croissant pour les résidences secondaires et le tourisme rural. De nombreux chalets traditionnels sont rénovés pour accueillir des familles en quête de tranquillité et d&apos;authenticité. Ces rénovations nécessitent une expertise particulière pour moderniser les salles de bain, les cuisines et les sols tout en préservant l&apos;âme des vieilles bâtisses.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Société de carrelage à Nax et dans la région Mont-Noble</h3>
                <p>
                  Notre équipe intervient à Nax et dans les autres hameaux de Mont-Noble : Mase, Saint-Martin, Vernamiège. Nous comprenons les spécificités des constructions en montagne : isolation renforcée, matériaux résistants aux variations thermiques, et adaptation aux accès par des chemins de montagne parfois enneigés ou escarpés. Que vous possédiez un chalet ancestral ou une maison rénovée, nous vous accompagnons dans votre projet de carrelage avec le souci du détail qui caractérise notre métier. Devis gratuit et déplacement rapide à Nax et dans toute la région Mont-Noble.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/nax-realisation.jpg"
                  alt="Réalisation carrelage Nax"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">400</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants à Nax</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1300 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Gratuit</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur place</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Nax</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis gratuit à Nax</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on monte à Nax et dans toute la région Mont-Noble. On regarde votre espace, on discute, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Nax</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Nax, Mase, Saint-Martin, Vernamiège — on connaît ces villages. Les vieux chalets à rénover, les constructions plus récentes à finir, les contraintes du climat de montagne. On monte nos outils là-haut et on pose du carrelage qui résiste.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit à Nax
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Nax"
        faqs={[
          {
            question: "Intervenez-vous à Mase et Saint-Martin depuis Nax ?",
            answer: "Oui, on intervient dans tout le district d'Hérens : Nax, Mase, Saint-Martin, Vernamiège. Les chemins de montagne ne nous arrêtent pas. On connaît les particularités de chaque village et on s'adapte aux contraintes d'accès."
          },
          {
            question: "Quels matériaux résistent aux hivers de Mont-Noble ?",
            answer: "En altitude à Nax, les hivers sont rigoureux. On recommande des grès cérame classés résistant au gel, avec des coefficients de dilatation adaptés. Pour les extérieurs, on utilise des joints spéciaux qui résistent aux cycles gel-dégel. Les pierres naturelles locales sont aussi un excellent choix pour l'esthétique montagnarde."
          },
          {
            question: "Comment posez-vous du carrelage dans les vieux chalets de Nax ?",
            answer: "Les vieux chalets de Nax ont des sols en bois et des murs en pierre. On adapte la technique de pose : ragréage spécifique pour les sols irréguliers, matériaux qui respirent pour éviter les problèmes d'humidité, et finitions qui respectent l'authenticité du bâtiment."
          },
          {
            question: "Faites-vous des devis pour les résidences secondaires à Nax ?",
            answer: "Oui, on travaille régulièrement sur des résidences secondaires à Nax et dans la région. On comprend les contraintes spécifiques : travail en l'absence du propriétaire, coordination avec d'autres artisans, et respect des délais pour la saison d'ouverture."
          },
          {
            question: "Quel délai faut-il prévoir pour une rénovation à Nax ?",
            answer: "En montagne, il faut compter des délais légèrement plus longs qu'en plaine à cause des accès et des conditions météo. Une rénovation de salle de bain prend généralement 3 à 5 semaines. On planifie les chantiers en fonction de la saison pour éviter les problèmes de livraison par temps de neige."
          },
          {
            question: "Proposez-vous des solutions économiques pour les petites surfaces ?",
            answer: "Oui, on s'adapte à tous les budgets. Pour les petites surfaces des chalets de Nax, on propose des solutions astucieuses : carrelage en format moyen pour limiter les découpes, mosaïque en feuille pour les détails, et optimisation des matériaux pour réduire les chutes."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
